class EnumCommon {
    constructor(value) {
        this.value = value;
        this.label = this.labels()[value] ?? null;
        const constructor = this.constructor;
        if (typeof EnumCommon._enums[constructor.NAME] == 'undefined') {
            EnumCommon._enums[constructor.NAME] = {};
        }
        EnumCommon._enums[constructor.NAME][this.value] = this;
    }
    getValue() {
        return this.value;
    }
    getLabel() {
        return this.label;
    }
    toString() {
        return this.getLabel();
    }
    static getByValue(value) {
        return EnumCommon._enums[this.NAME][value];
    }
}
EnumCommon._enums = {};
export default EnumCommon;
